var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIconYo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9258,
    cy: 16,
    r: 16,
    fill: "#D9F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7647 11.3856C25.552 10.5947 24.9284 9.97128 24.1376 9.75832C22.6929 9.36304 16.9141 9.36304 16.9141 9.36304C16.9141 9.36304 11.1356 9.36304 9.69088 9.74333C8.9153 9.95607 8.27652 10.5949 8.06378 11.3856C7.68359 12.8302 7.68359 15.826 7.68359 15.826C7.68359 15.826 7.68359 18.837 8.06378 20.2664C8.27674 21.0572 8.90009 21.6807 9.69099 21.8936C11.1508 22.289 16.9144 22.289 16.9144 22.289C16.9144 22.289 22.6929 22.289 24.1376 21.9087C24.9285 21.6959 25.552 21.0724 25.7649 20.2816C26.145 18.837 26.145 15.8412 26.145 15.8412C26.145 15.8412 26.1602 12.8302 25.7647 11.3856ZM15.0743 18.5937V13.0584L19.8797 15.826L15.0743 18.5937Z",
    fill: "#252A34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6923,
    height: 19.6923,
    fill: "white",
    transform: "translate(7.07812 6.15381)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconYo);
export default __webpack_public_path__ + "static/media/FooterIconYo.d89d6a1c518008ca6f6f3b9396034f55.svg";
export { ForwardRef as ReactComponent };